<div
  class="flex flex-row gap-2 justify-center cursor-pointer rounded-lg w-full overflow-hidden items-center px-4 py-2 sm:py-2 sm:px-1 hover:bg-surface-800 duration-150 transition-colors text-white"
  (click)="userMenu.toggle($event)"
>
  <p-avatar
    [label]="
      userAvatar()
        ? ''
        : userService.currentUser()
          ? userService.currentUser()!.firstName!.charAt(0) +
            userService.currentUser()!.lastName!.charAt(0)
          : 'U'
    "
    [image]="userAvatar()"
    shape="circle"
    size="normal"
    class="shrink-0"
  />
  @if (!collapsed()) {
    <span class="overflow-hidden text-ellipsis whitespace-nowrap">
      @if (userService.currentUser()) {
        {{ userService.currentUser()!.firstName }}
        {{ userService.currentUser()!.lastName }}
      } @else {
        <p-skeleton width="8rem" borderRadius="1rem" height="1.5rem" />
      }
    </span>
  }
</div>
<p-menu #userMenu [model]="items()" [popup]="true" appendTo="body">
  <ng-template #start>
    <div class="flex flex-row gap-2 py-2 px-4 items-center">
      <p-avatar
        [label]="
          userAvatar()
            ? ''
            : userService.currentUser()
              ? userService.currentUser()!.firstName!.charAt(0) +
                userService.currentUser()!.lastName!.charAt(0)
              : 'U'
        "
        [image]="userAvatar()"
        shape="circle"
        size="normal"
        class="shrink-0"
      />
      <span>
        {{ userService.currentUser()?.firstName }}
        {{ userService.currentUser()?.lastName }}
      </span>
    </div>
  </ng-template>
</p-menu>
